<template>
  <el-dialog
      @open="handleOpen"
      :visible.sync="isOpenRegisterBankForOrderDialog"
      top="30vh" width="700px"
      :close-on-click-modal="false"
      title="Chọn tài khoản thanh toán trực tuyến">
    <el-form
        label-width="140px"
        :model="formData"
        label-position="left"
        :rules="rules"
        ref="formData"
    >
      <el-form-item label="Chọn tài khoản" prop="idBank">
        <el-select v-model="formData.idBank" placeholder="Chọn tài khoản" style="width: 500px">
          <el-option
              v-for="item in banks"
              :key="item.id"
              :label="item.nameAccount + ' - ' + item.numberAccount"
              :value="item.id"
          >
            <div style="display: flex; align-items: center;">
              <img :src="item.logo" alt="logo" style="width: 24px; height: 24px; margin-right: 8px;"/>
              <span>{{ item.nameAccount }} - {{ item.numberAccount }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
          <el-button
              type="danger"
              size="medium"
              @click="handleClose"
          >
              <i class="el-icon-circle-close"/>
        <span>Đóng</span>
         </el-button>
         <el-button
             type="success"
             size="medium"
             @click="submitForm()"
         >
        <i class="el-icon-circle-check"/>
        <span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>
<script>

import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: 'RegisterBankForOrderDialog',
  props: {
    isOpenRegisterBankForOrderDialog: {
      type: Boolean,
      default: () => false
    },
    month: {
      type: Number,
      default: () => 0
    },
    year: {
      type: Number,
      default: () => 0
    },
    turn: {
      type: Number,
      default: () => 0
    },
    idKids: {
      type: Array,
      default: () => []
    },
    idGroup: {
      type: Number,
      default: () => 0
    },
  },
  data() {
    return {
      formData: {
        idBank: "",
        month: 0,
        year: 0,
        turn: 0,
        idKids: [],
      },
      banks: [],
      rules: {
        idBank: [
          {
            required: true,
            message: "Tài khoản không được để trống",
            trigger: "change",
          },
        ],
      },
    }
  },
  methods: {
    handleOpen() {
      this.formData.month = this.$props.month;
      this.formData.year = this.$props.year;
      this.formData.turn = this.$props.turn;
      this.formData.idGroup = this.$props.idGroup;
      this.formData.idKids = this.$props.idKids;
      sePayConnectionService.findListBankForSchool().then(resp => {
        this.banks = resp.data.data;
      }).catch(err => {
        console.log(err);
      })
    },
    handleClose() {
      this.formData.idBank = ""
      this.banks = []
      this.$emit("close");
    },
    submitForm() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          sePayConnectionService.registerBankAccountForSchool(this.formData)
              .then(() => {
                NotifyMessage.leftCornerNotificationSuccess("Đăng ký thành công")
              })
              .catch(() => {
                NotifyMessage.leftCornerNotificationError("Đăng ký thất bại")
              }).finally(() =>{
                this.handleClose()
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>

</style>